define('presentation/common/callDetails/presentationObjects/firstCallDetailStepPresentationObject',[],function () {
    return function () {
        const self = this;

        self.callDateTime = null;
        self.hasCallRecording = null;
        self.hasVoicemail = null;
        self.otherPartyObjectId = null;
        self.otherPartyPhoneNumber = null;
        self.otherPartyType = null;
        self.otherPartyLocation = null;
        self.callDurationInSeconds = null;
        self.disposition = null;
        self.isInbound = null;
        self.humanDetectionFailed = null;
    };
});

